import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-input',
  templateUrl: './formly-input.component.html',
  styleUrl: './formly-input.component.scss',
  imports: [NgTemplateOutlet, FormlyModule, FormsModule, ReactiveFormsModule],
})
export class FormlyInputComponent extends FormlyFieldBaseComponent {
  get type() {
    return this.props.type ?? 'text';
  }

  // Number boxes drop the browser's up/down spinner arrows unless the field opts back in with
  // props.showSpinner - a system-wide default across every app, not a per-customer setting
  // (4Spaces point 2, Sep 2026). The class is styled in tms-lib/styles/_form.scss.
  get hideSpinner() {
    return this.type === 'number' && !this.props.showSpinner;
  }

  keyUpEnter(event: any) {
    if (this.props.enter) {
      this.props.enter(event);
    }
  }

  keyUpBackspace(event: any) {
    if (this.props.backspaceReset) {
      this.clear();
    }
    if (this.props.backspace) {
      this.props.backspace(event);
    }
  }
  onClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  onAppendClick() {
    if (this.props.appendClick) {
      this.props.appendClick();
    }
  }

  onFocus() {
    if (this.props.focusReset) {
      this.clear();
    }
  }

  private clear() {
    this.form.patchValue({ [this.key]: undefined } as any);
  }
}
